// services/CitySponsorService.js

import { buildFormData } from "@/utils/commonUtils";
import httpService from "./httpService";
import { assertRequired, getWithQuery } from "@/services/utils/requestHelpers";

const headers = { "Content-Type": "multipart/form-data" };

const SponsorService = {
    getMapAll: async (props) => {
        return await getWithQuery(httpService, "map/sponsors", props);
    },
    getId: async (id) => {
        assertRequired(id, "Sponsor ID is required");
        return await httpService.get(`front/sponsors/${id}`);
    },
    getAll: async (props) => {
        return await getWithQuery(httpService, "sponsors", props);
    },
    create: async (payload) => {
        const formData = buildFormData(payload);
        return await httpService.post("sponsors/create", formData, { headers });
    },
    update: async (payload) => {
        const { id } = payload || {};
        assertRequired(id, "Sponsor ID is required for update");
        const formData = buildFormData({ _method: "PUT", ...payload });
        return await httpService.post(`sponsors/update/${id}`, formData, { headers });
    },
    delete: async (id) => {
        assertRequired(id, "Sponsor ID is required for deletion");
        return await httpService.delete(`sponsors/${id}`);
    },
};

export default SponsorService;

